import React from "react";
import MediaContent from "../ui/MediaContent";

const RESIZE_HANDLE_STYLE = {
    position: "absolute", right: -5, bottom: -5,
    width: 10, height: 10,
    backgroundColor: "#1976d2", border: "2px solid #fff",
    cursor: "se-resize", zIndex: 100,
};

export default function ElementRenderer({ el, isSelected, onMouseDown, onResizeMouseDown }) {
    const base = {
        position: "absolute",
        left: el.x, top: el.y,
        width: el.width, height: el.height,
        zIndex: el.zIndex,
        cursor: "move",
        boxSizing: "border-box",
        userSelect: "none",
        outline: isSelected ? "2px solid #1976d2" : "none",
        outlineOffset: "1px",
    };

    const resizeHandle = isSelected
        ? <div onMouseDown={e => onResizeMouseDown(e, el.id)} style={RESIZE_HANDLE_STYLE} />
        : null;

    if (el.type === "text") return (
        <div style={base} onMouseDown={e => onMouseDown(e, el.id)}>
            <span style={{
                fontSize: el.fontSize,
                fontFamily: el.fontFamily,
                fontWeight: el.fontWeight,
                fontStyle: el.fontStyle,
                textDecoration: el.textDecoration,
                color: el.color,
                textAlign: el.textAlign,
                display: "block",
                width: "100%",
                whiteSpace: "pre-wrap",
            }}>
                {el.text}
            </span>
            {resizeHandle}
        </div>
    );

    if (el.type === "rect") return (
        <div
            style={{
                ...base,
                backgroundColor: el.noFill ? "transparent" : el.fill,
                border: el.noBorder ? "none" : `${el.strokeWidth}px solid ${el.stroke}`,
                borderRadius: el.borderRadius,
                opacity: el.opacity,
            }}
            onMouseDown={e => onMouseDown(e, el.id)}
        >
            {resizeHandle}
        </div>
    );

    if (el.type === "circle") return (
        <div
            style={{
                ...base,
                backgroundColor: el.noFill ? "transparent" : el.fill,
                border: el.noBorder ? "none" : `${el.strokeWidth}px solid ${el.stroke}`,
                borderRadius: "50%",
                opacity: el.opacity,
            }}
            onMouseDown={e => onMouseDown(e, el.id)}
        >
            {resizeHandle}
        </div>
    );

    if (el.type === "image") return (
        <div
            style={{ ...base, overflow: "hidden", opacity: el.opacity }}
            onMouseDown={e => onMouseDown(e, el.id)}
        >
            <MediaContent src={el.src} pointerEvents="none" />
            {resizeHandle}
        </div>
    );

    return null;
}
